import axios from "axios";
// import store from "./App";

// axios start
// axios.defaults.baseURL = "http://172.16.5.67:4000";
// axios.defaults.baseURL = "http://172.16.5.18:4001";
// axios.defaults.baseURL = "http://172.16.5.15:4000";
// axios.defaults.baseURL = "http://172.16.5.10:6009";

//staging
axios.defaults.baseURL = "https://staging5kcar.treeone.one/";

//Live
// axios.defaults.baseURL = "https://admin.5kcarcare.com/v4";

//Interceptor;
axios.interceptors.request.use(
  (config) => {
    const token = global.$userData?.token;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    console.log("Token Error", error);
  }
);

axios.interceptors.response.use(function (response) {
  if (
    response.data.status === "failed" &&
    response.data.message === "invalid token"
  ) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Invalid token"); // or return an error response
  }
  return response;
});

global.$axios = axios;
// axios end
